"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Stack = void 0;
const React = __importStar(require("react"));
const palette_1 = require("../../lib/palette");
const StackElement_1 = require("./StackElement");
const Stack = (props) => {
    return React.createElement("div", { className: "stack-container container" },
        props.fractions.map(fraction => React.createElement(StackElement_1.StackElement, { color: palette_1.palette[fraction.id], percentage: fraction.percentage })),
        React.createElement(StackElement_1.StackElement, { color: palette_1.palette[palette_1.palette.length - 1], percentage: props.remainder }));
};
exports.Stack = Stack;
